// src/components/MaintenanceHoldingPage.tsx — Phase 9 c14.
//
// Shown to non-admin users when me.systemMaintenance.active === true.
// Admins bypass this gate so they can reach the maintenance toggle in
// User Access and disable it.
//
// Copy: the defaultBanner is owned server-side (DEFAULT_MAINTENANCE_BANNER
// constant) and arrives on /api/me. The optional admin message renders
// below it. No retry button or poll — users sign out and back in when
// the toggle is lifted (next /api/me on a fresh session picks up the new
// state).

import type { SystemMaintenanceState } from "../auth";
import { C, F, layout } from "../theme";

interface MaintenanceHoldingPageProps {
  state: SystemMaintenanceState;
}

export function MaintenanceHoldingPage({ state }: MaintenanceHoldingPageProps) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: C.paper,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
        fontFamily: F.body,
      }}
    >
      <div
        style={{
          maxWidth: 520,
          width: "100%",
          background: C.card,
          border: `1px solid ${C.hairline}`,
          borderRadius: 18,
          padding: "32px 28px",
          boxShadow: C.shadowM,
          textAlign: "center",
        }}
      >
        <div
          aria-hidden="true"
          style={{
            width: 72,
            height: 72,
            borderRadius: 18,
            background: C.brassBg,
            border: `1px solid ${C.brassLt}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 22px",
          }}
        >
          <svg width={36} height={36} viewBox="0 0 24 24" fill="none" stroke={C.brassDk} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="9"/>
            <path d="M12 7v5l3 2"/>
          </svg>
        </div>

        <h1
          style={{
            fontFamily: F.serif,
            fontSize: 26,
            fontWeight: 700,
            color: C.ink,
            margin: "0 0 14px",
            letterSpacing: -0.4,
            lineHeight: 1.2,
          }}
        >
          NYMR Info Hub — temporarily unavailable
        </h1>

        <p
          style={{
            fontSize: 15,
            color: C.inkSoft,
            fontWeight: 600,
            lineHeight: 1.55,
            margin: "0 0 18px",
          }}
        >
          {state.defaultBanner}
        </p>

        {state.message && (
          <div
            style={{
              padding: "14px 16px",
              background: C.paperWarm,
              border: `1px solid ${C.hairline}`,
              borderRadius: 12,
              fontFamily: F.serif,
              fontStyle: "italic",
              fontSize: 14,
              color: C.ink,
              lineHeight: 1.55,
              textAlign: "left",
              whiteSpace: "pre-wrap",
            }}
          >
            {state.message}
          </div>
        )}

        <div
          style={{
            marginTop: 22,
            fontFamily: F.mono,
            fontSize: 11,
            color: C.inkMute,
            fontWeight: 600,
            letterSpacing: 0.4,
            textTransform: "uppercase",
          }}
        >
          NYMR · maintenance mode
        </div>
      </div>

      <div
        aria-hidden="true"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          height: layout.bottomNavH,
          pointerEvents: "none",
        }}
      />
    </div>
  );
}
